import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { breakpoints } from 'globalStyles'
import Button from 'react-bootstrap/Button'
import { useTranslation } from 'react-i18next'

const StyledPopUp = styled(Modal)`
  .modal-dialog.modal-dialog-centered {
    justify-content: center;
  }
  .modal-body {
    text-align: center;
    margin-top: 10px;
    margin-bottom: -10px;
    @media ${breakpoints.desktop} {
      margin-left: 90px;
      margin-right: 90px;
    }
  }

  .modal-footer {
    border-top: none;
    justify-content: center;
    display: flex;
    gap: 6px;
    padding-bottom: 30px;
  }

  .modal-content {
    max-width: 330px;
    @media ${breakpoints.desktop} {
      max-width: 500px;
      height: 182px;
    }
  }

  button.cancelPopUpSecBtn.btn.btn-secondary,
  button.cancelPopUpPrimBtn.btn.btn-primary {
    width: 141px;
    @media ${breakpoints.desktop} {
      width: 214px;
    }
  }
`

const CancelPopUp = ({ popUpText, show, onClickYes, onClickNo }) => {
  const { t } = useTranslation()
  return (
    <StyledPopUp show={show} backdrop="static" centered>
      <StyledPopUp.Body>{popUpText}</StyledPopUp.Body>
      <StyledPopUp.Footer>
        <Button variant="secondary" onClick={onClickNo} className="cancelPopUpSecBtn">
          {t('buttonActions.no')}
        </Button>
        <Button type="submit" variant="primary" onClick={onClickYes} className="cancelPopUpPrimBtn">
          {t('buttonActions.yes')}
        </Button>
      </StyledPopUp.Footer>
    </StyledPopUp>
  )
}

CancelPopUp.propTypes = {
  popUpText: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onClickYes: PropTypes.func.isRequired,
  onClickNo: PropTypes.func.isRequired,
}

export default CancelPopUp
